import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import Vitrine from './components/Vitrine';



import reportWebVitals from './reportWebVitals';



ReactDOM.render(
  
  
  
 <Vitrine />

 ,
  document.getElementById('root')
);


reportWebVitals();
